import { useState, RefObject, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Spinner } from 'UIPackage/MainModule/components/Spinner';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Section } from 'UIPackage/FormModule/components/Section';

import { IKnmHistoryItemChanges } from '../interfaces/IKnmHistoryItemChanges';
import { KnmHistoryItem } from './KnmHistoryItem';
import styles from './KnmHistory.module.scss';

const PAGE_SIZE = 10;

interface IKnmHistoryProps {
  id: string;
  title: string;
  blockRef?: RefObject<HTMLDivElement>;
  loading: boolean;
  historyChanges: IKnmHistoryItemChanges[];
}

export const KnmHistory = ({ id, title, blockRef, loading, historyChanges }: IKnmHistoryProps) => {
  const [itemsPage, setItemsPage] = useState<number>(0);

  const lastVisibleItemsNumber = (itemsPage + 1) * PAGE_SIZE;
  const isLoadMoreButtonVisible = historyChanges.length > lastVisibleItemsNumber;

  const handleLoadMoreButtonClick = useCallback(() => setItemsPage(prev => prev + 1), []);

  return (
    <Section title={title} id={id}>
      <div ref={blockRef} />
      {loading && <Spinner className={styles.Loader} />}

      {historyChanges.length > 0 && (
        <div className={styles.Items}>
          {historyChanges.map((knmHistoryItem, index) => {
            if (index > lastVisibleItemsNumber - 1) {
              return null;
            }

            return <KnmHistoryItem key={uuidv4()} data={knmHistoryItem} />;
          })}
        </div>
      )}

      {isLoadMoreButtonVisible && (
        <Button type="button" text="Показать еще" color="load" onClick={handleLoadMoreButtonClick} />
      )}
    </Section>
  );
};
